"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var BasicMenu_1 = __importDefault(require("../BasicMenu/BasicMenu"));
var LinkItem_1 = __importDefault(require("../LinkItem"));
var useBasicMenu_1 = __importDefault(require("./useBasicMenu"));
var useMenuWithLinksItemContainer_1 = __importDefault(require("./useMenuWithLinksItemContainer"));
var MenuWithLinksItemContainer = function (props) {
    var _a = props.onClickFns, onClickFns = _a === void 0 ? [] : _a;
    var useBasicMenuStates = useBasicMenu_1.default();
    var handleClick = useBasicMenuStates.handleClick, handleClose = useBasicMenuStates.handleClose;
    var handleClickFn = useMenuWithLinksItemContainer_1.default(handleClose, onClickFns).handleClickFn;
    return (react_1.default.createElement(BasicMenu_1.default, __assign({}, useBasicMenuStates, { onClick: handleClick, onClose: handleClose, menuName: props.link.title, linkChildren: props.link.children }), props.link.children.map(function (link, i) { return (react_1.default.createElement(LinkItem_1.default, __assign({ key: i }, link, { onClick: handleClickFn(i) }))); })));
};
exports.default = MenuWithLinksItemContainer;
